import { getIsPositionUnhealthy } from '@morpho-org/dapp-core'
import { isDefined } from '@morpho-org/morpho-ts'

export interface RefinanceFinalPositionRiskParams {
  sourceLtv: bigint | undefined
  targetLtv: bigint | undefined
  sourceProtectedLltv: bigint | null | undefined
  targetProtectedLltv: bigint | null | undefined
}

/**
 * Splits the refinance risk verdict into the warning band (at least 95% but below 100% of the
 * protected threshold) and the hard-stop band (at/above that threshold).
 *
 * The protected threshold is the Auto-Deleverage pre-LLTV when enabled, not
 * necessarily the market's raw LLTV. A position at/above it can be acted on by
 * the pre-liquidation contract, so acknowledgment is not enough there.
 */
export const getRefinanceFinalPositionRisk = ({
  sourceLtv,
  targetLtv,
  sourceProtectedLltv,
  targetProtectedLltv
}: RefinanceFinalPositionRiskParams) => {
  const isAtOrAboveThreshold = (
    ltv: bigint | undefined,
    protectedLltv: bigint | null | undefined
  ) => isDefined(ltv) && isDefined(protectedLltv) && ltv >= protectedLltv

  const isCloseToThreshold = (ltv: bigint | undefined, protectedLltv: bigint | null | undefined) =>
    isDefined(ltv) &&
    isDefined(protectedLltv) &&
    ltv < protectedLltv &&
    getIsPositionUnhealthy(ltv, protectedLltv)

  return {
    isAtOrAboveProtectedLltv:
      isAtOrAboveThreshold(sourceLtv, sourceProtectedLltv) ||
      isAtOrAboveThreshold(targetLtv, targetProtectedLltv),
    isCloseToProtectedLltv:
      isCloseToThreshold(sourceLtv, sourceProtectedLltv) ||
      isCloseToThreshold(targetLtv, targetProtectedLltv)
  }
}
